/**
 * Param / banka callback'leri bazen farklı büyük-küçük harf ile query gönderebiliyor.
 */
export function firstQueryParam(searchParams: URLSearchParams, keys: string[]): string | null {
  for (const k of keys) {
    const v = searchParams.get(k);
    if (v !== null && v !== '') return v;
  }
  return null;
}
